import styled from "styled-components";

export const Container = styled.div`
    width: 98%;

    & + &{
        margin-top: 1rem;
    }
`

export const Content = styled.div`
    width: 100%;
    color: #FFF5FF;
    height: 10rem;
    background: linear-gradient( 315deg, rgba(0,83,220,0.9), rgba(122,5,167,1));
    border-radius: 0.7rem;
    position: relative;

    display: grid;
    grid-template-columns: 1fr 0.2fr;
    grid-template-rows: 1fr;

    .buttonSelect{
        border-left: 3px dashed #FFF5FF;
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        align-items: center;
        font-size: 0.6rem;
        text-align: center;

        div{
            display: flex;
            justify-content: center;
            align-items: center;
            flex-direction: column;

            @media (min-width: 960px){
                cursor: pointer;
            }
        }

        svg{
            font-size: 1.3rem;
            margin-bottom: 0.3rem;
        }
    }
`

export const ContentCoupom = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    
    .remaining{
        position: absolute;
        bottom: 2px;
        font-size: 0.7rem;

        display: flex;
        align-items: center;
        gap: 0.5rem;

        &:hover {
            div {
                opacity: 1;
                z-index: 99;
            }
        }

        div {
            background: #FFF5FF;
            color: #000;
            width: max-content;
            padding: 1rem;
            transform: translate(-10%, 100%);
            z-index: -9;
            border-radius: 4px;
            opacity: 0;
            transition: all 0.2s;

            p{
                display: flex;
                gap: 1rem;
                
                strong {
                    flex: auto;
                }

                & + p {
                    margin-top: 0.25rem;
                }
            }

            position: absolute;
            bottom: 0;
        }
    }
`

export const Text = styled.div`
    height: 80%;
    width: 80%;
    border: 2px solid #FFF5FF;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 0.7rem;

    strong{
        font-size: 1.2rem;
    }
`

export const BallLeft = styled.div`
    border-radius: 50%;
    top: 50%;
    position: absolute;
    left: -1.3rem;
    height: 2.4rem;
    width: 2.4rem;
    transform: translateY(-50%);   
    z-index: 10; 

    display: flex;
    overflow: hidden;

    &:before{
        content: '';
        flex: 1;
        background: transparent;
    }

    &:after{
        content: '';
        flex: 1;
        background: #FFF;
    }
`